import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter
} from '@angular/core';

import { SvgIconNameEnum } from '../../enums/svg-icon-name.enum';
import { IDrawerComponentLiaison } from '../../interfaces/idrawer-component-liaison';
import { DrawerComponentBase } from '../drawer-component-base/drawer-component-base.component';

export class FavoriteInfo {
    // Properties.
    public isFavorite: boolean;
    public favoriteTitle: string;

    // Constructor.
    public constructor(isFavoriteParam: boolean,
        favoriteTitleParam: string) {
        this.isFavorite = isFavoriteParam;
        this.favoriteTitle = favoriteTitleParam;

        return;
    }
}

@Component({
    selector: 'app-toggle-favorite',
    templateUrl: './toggle-favorite.component.html',
    styleUrls: ['./toggle-favorite.component.scss'],
    standalone: false
})
export class ToggleFavoriteComponent extends DrawerComponentBase implements OnInit {
    // Inputs and outputs.
    @Input() isFavorite: boolean;
    @Input() title: string;
    @Input() drawerComponentLiaison: IDrawerComponentLiaison = null;

    @Output() save: EventEmitter<FavoriteInfo> = new EventEmitter<FavoriteInfo>();
    @Output() cancel: EventEmitter<void> = new EventEmitter();

    // Internal properties.
    private bIsFavorite: boolean = false;
    private favoriteTitle: string = '';

    // Constructor.
    public constructor()
    {
        super();
    }

    public ngOnInit(): void {
        super.ngOnInit(); // Important to call this as the first line in this method.

        this.bIsFavorite = !this.isFavorite;
        this.favoriteTitle = this.title;

        return;
    }

    // Accessor methods used by my HTML.
    public get IsFavorite(): boolean {
        return (this.bIsFavorite);
    }

    public set IsFavorite(bIsFavoriteParam: boolean) {
        this.bIsFavorite = bIsFavoriteParam;

        return;
    }

    public get FavoriteIconName(): string {
        let iconName: string =
            (this.bIsFavorite ?
                SvgIconNameEnum.STAR_FILLED_BLUE :
                SvgIconNameEnum.STAR_UNFILLED);

        return (iconName);
    }

    public get IsReadOnly(): boolean {
        return (!this.bIsFavorite);
    }

    public get FavoriteTitleLabelText(): string {
        return('Favorite Title')
    }

    public get PlaceholderText(): string {
        let placeholderText: string =
            (this.bIsFavorite ?
                'Enter a favorite title' :
                'Title disabled when not favorite');

        return (placeholderText);
    }

    public get FavoriteTitle(): string {
        return (this.favoriteTitle);
    }

    public set FavoriteTitle(titleParam: string) {
        this.favoriteTitle = titleParam;

        return;
    }

    public get SaveDisabled(): boolean {
        let bIsDisabled: boolean = (this.favoriteTitle == null);

        return (bIsDisabled);
    }

    // Handle control events.
    public handleIsFavoriteChanged(): void {
        return;
    }

    public toggleFavorite(): void {
        this.bIsFavorite = (!this.bIsFavorite);

        return;
    }

    public onSave(): void {
        let favoriteInfo: FavoriteInfo =
            new FavoriteInfo(this.bIsFavorite, this.favoriteTitle);

        //this.save.emit(this.bIsFavorite);
        this.save.emit(favoriteInfo);

        return;
    }

    public onCancel(): void {
        this.cancel.emit();

        return;
    }
}
